module.exports = __webpack_public_path__ + "static/media/contact-message.a623f23c.svg";